import React from 'react';

import { withFoldersAndDocsActions } from '../../../hocs/withFoldersAndDocsActions';

import DraggableFolderNavItem from '../DraggableFolderNavItem/DraggableFolderNavItem';

const SidePanelFolderNavList = ({ sidePanelFolders, expandedFolders, setActionModal }) => {
    return (
        <ul className="flex flex-col gap-1 max-w-full">
            {sidePanelFolders?.map((folder) => {
                const currentFolderExpandedState = expandedFolders[folder.id];

                return (
                    <DraggableFolderNavItem
                        key={folder.id}
                        folder={folder}
                        isTopLevel
                        currentFolderExpandedState={currentFolderExpandedState}
                        prevFoldersLocation={[]}
                        setActionModal={setActionModal}
                    />
                );
            })}
        </ul>
    );
};

export default withFoldersAndDocsActions(SidePanelFolderNavList);
